var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('section',[_c('img',{attrs:{"src":`${_vm.baseURL}/storage/app/img/judge/${_vm.data.judge_picture}`}}),_c('div',{staticClass:"box-content"},[_c('div',{staticClass:"box"}),_c('div',{staticClass:"box-text"},[_c('h2',[_vm._v(_vm._s(_vm.data.name_judge))]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.data.content)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }